import appConfig from "../config/app-config";

const { address: API_URL, key: API_KEY } = appConfig.apis.convertXmlApiEnv;

export interface CloseOperationRequest {
    contract_code?: string;
    disbursement_value?: number;
    indexer?: string;
    rate?: number;
    operation_guarantee?: string;
}

export interface CloseOperationResponse {
    success: boolean;
    message: string;
    operation_id?: string;
    operation_code?: string;
}

export const closeOperation = async (operationId: string, data: CloseOperationRequest): Promise<CloseOperationResponse> => {
    const response = await fetch(`${API_URL}/operations/${operationId}/close`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-api-key': API_KEY
        },
        body: JSON.stringify(data)
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
};
